/* @flow */
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import { withPhoneCallPermissions } from 'phoneCalls/lib/permissions';

type WrapperProps = {
  loading?: React.Element<any>,
  can?: React.Element<any>,
  cannot?: React.Element<any>,
  injector?: *,
};

type Props = {
  dataLoading: boolean,
  canMakePhoneCalls: boolean,
};

/* Render component based on whether the user can make phone calls
 *
 * <CanMakePhoneCalls can={<SomeCoolComponent />} cannot={<SomeOldComponent />} />
 *
 */
function CanMakePhoneCalls(wrapperProps: WrapperProps): ?React.Element<*> {
  const { loading, can, cannot, injector } = wrapperProps;

  const canCase = can || null;
  const cannotCase = cannot || null;
  const loadingCase = loading || null;

  if (!CurrentUser.isSignedIn()) {
    return cannotCase;
  }

  const CanMakePhoneCallsComponent = (injector || withPhoneCallPermissions)(function(props: Props) {
    const { canMakePhoneCalls, dataLoading } = props;

    if (dataLoading || canMakePhoneCalls === undefined) {
      return loadingCase;
    }

    if (!CurrentUser.getUser()) {
      return cannotCase;
    }

    return canMakePhoneCalls || CurrentUser.getUser().hasFeature('phone_calls')
      ? canCase
      : cannotCase;
  });

  return <CanMakePhoneCallsComponent />;
}

export { CanMakePhoneCalls };
export default CanMakePhoneCalls;
